// Thực thể Tệp job (M-DT): JSON của /v1/files (kho tệp job / chứng từ, SQL 011) → kiểu cho trình xem tệp.
// Chỉ cột nghiệp vụ — KHÔNG tiền (khớp SQL 011: không Amount / USDAmount / ROE / TotalAmount).
import type { ApiRoute } from './api';

export interface JobFileRow {
  id: string;
  jobId: string;
  /** mã chứng từ (BKG, SI, HBL, OPS…) */
  docCode: string;
  /** loại tệp (Booking file, House BL…) */
  type: string;
  mbl: string;
  by: string;
  url: string;
  ref: string;
  locked: boolean;
}

declare module './source' {
  interface Entities {
    jobFile: JobFileRow;
  }
}

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : '');

export function jobFileFromApi(r: Row): JobFileRow {
  return {
    id: str(r.IDFile),
    jobId: str(r.JobID),
    docCode: str(r.DocCode),
    type: str(r.TypeDoc),
    mbl: str(r.MBL),
    by: str(r.UserCreated),
    url: str(r.URLFileLink) || str(r.UrlFile),
    ref: str(r.Ref),
    locked: r.DonotDelete === true,
  };
}

export const jobFileRoute: ApiRoute<JobFileRow> = {
  path: '/api/v1/files',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    const w = q.where ?? {};
    return {
      q: q.q?.trim(),
      job: w.job === undefined ? undefined : String(w.job),
      type: w.type === undefined ? undefined : String(w.type),
      limit,
      page: Math.floor((q.offset ?? 0) / limit) + 1,
    };
  },
  parse: (json) => {
    const list = (json as { items?: unknown } | null)?.items;
    return { items: Array.isArray(list) ? (list as Row[]).map(jobFileFromApi) : [], hasMore: (json as { hasMore?: boolean } | null)?.hasMore === true };
  },
};
